import { api } from "../api";
import { Notice, Spinner, useAsync } from "../components/common";
import { insideTelegram } from "../telegram";
import { PersonCard } from "../views/PersonCard";

/**
 * The reason the app exists: open it, and your own eight years are already
 * there. No sign-up, no profile to fill in — Telegram's `initData` carries the
 * same numeric id the 2018 export recorded.
 */
export function MeTab({ onOpenThread }: { onOpenThread: (id: number) => void }) {
  const { data, loading, error } = useAsync(() => api.me(), []);

  if (loading) return <Spinner />;

  if (error) {
    return (
      <Notice>
        {error}
        {!insideTelegram() && (
          <p style={{ marginBottom: 0 }}>
            Приложение открыто вне Telegram. Для локальной разработки добавьте в адрес{" "}
            <code>?dev_user=&lt;tg id&gt;</code>.
          </p>
        )}
      </Notice>
    );
  }

  if (!data?.known) {
    return (
      <>
        <div className="screen-head">
          <div className="rail">записи не найдены</div>
          <h1>Вас тут ещё нет</h1>
          <p>{data?.message}</p>
        </div>
        <Notice>
          В архиве нет сообщений от вашего аккаунта. Напишите в чат — и профиль появится
          после ближайшей синхронизации.
        </Notice>
      </>
    );
  }

  return (
    <PersonCard
      card={data}
      onOpenThread={onOpenThread}
      self
      eyebrow="личное дело · видно только вам"
    />
  );
}
